import { Horo } from "../../core/lib/http-common";
class ConfigService {
  constructor() {
    this.cacheKey = "appConfig";
    this.expireKey = "appConfigExpire";
    this.config = null;
    this.config_value = null;
  }
  async loadConfig() {
    let json = {
      "test": "data"
    };
    try {
      const response = await Horo.post("1875/config/horoscope", json);
      this.config = response.data;
      console.log("Config loaded:", this.config);
      return this.config;
    } catch (error) {
      console.log("Error loading config:", error);
      
    }
  }  

  async getConfig() {
    console.log("Fetching config...");
    
  try {
      const now = Date.now();
    const cached = localStorage.getItem(this.cacheKey);
    const expire = localStorage.getItem(this.expireKey);
    const now_readable = new Date(now);
    const expire_readable = new Date(parseInt(expire));

    console.log('Before cached => ', cached, ' expire => ', expire, 'now => ', now);
    console.log(expire_readable.toLocaleString(), ' now => ', now_readable.toLocaleString());

    if (!cached || !expire || now > parseInt(expire)) {   
      // let form_data = ''
      // let res_status = ''
      let json = {
        // config_name: categoryName
      }
      let response = await Horo.post("1875/config/horoscope", json)
      console.log('Response from Horo => ', response);
      
        let data = response?.data || 'Fetched but fail';
      localStorage.setItem(this.cacheKey, JSON.stringify(data.config));
      localStorage.setItem(this.expireKey, (now + 1000 * 60 * 5).toString()); // 5 mins expire

      this.config = data.config;
      console.log('After cached => ', cached, ' expire => ', expire, ' now => ', now);

    } else {
      // ✅ Use cache
      this.config = JSON.parse(cached);
    }
    // console.log('Config in getConfig => ', this.config[0]);
    
    // alert('Config Service '+this.config[0].name+ ' : '+this.config[0].value);
    return this.config;
  } catch (error) {
    console.log('Error in getConfig:', error);
    
  }
  }
  getConfigValue(categoryName) {   
      this.config_value = this.config.find(item => item.name === categoryName) || null;
      return this.config_value;
  }
}

export default new ConfigService();
// export const configService = new ConfigService();

